/* global GM_STATE */
import { useEffect, useState } from 'preact/hooks'
import { getCart, getMaxQuantityByVariant } from 'libs/cart'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

function useCartGlobal(currentVariant) {
  const [cart, setCart] = useState(GM_STATE.cart.initCart)
  const [isFetching, setIsFetching] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [cartItems, setCartItems] = useState(GM_STATE.cart.initCart?.items)
  const [maxQuantity, setMaxQuantity] = useState(null)
  // const [isLoading, setIsLoading] = useState(true)

  const getMaxQuantity = async (variant) => {
    const cartData = await getCart()

    setCartItems(cartData.items)

    return getMaxQuantityByVariant(cartData.items, variant)
  }

  const syncMaxQuantity = async () => {
    if (!currentVariant) return
    // setIsLoading(true)

    const maxValue = await getMaxQuantity(currentVariant)

    setMaxQuantity(maxValue)
    // setIsLoading(false)
  }

  const updateMaxQuantity = (items) => {
    if (!currentVariant) return
    // setIsLoading(true)

    const maxValue = getMaxQuantityByVariant(items, currentVariant)

    setCartItems(items)
    setMaxQuantity(maxValue)
    // setIsLoading(false)
  }

  const cartUpdateListener = (items) => updateMaxQuantity(items)

  useEffect(() => {
    if (currentVariant) {
      updateMaxQuantity(cartItems, currentVariant)
      globalEmitter.on(emitterProps.cart.update, cartUpdateListener)
    }

    return () => {
      globalEmitter.off(emitterProps.cart.update, cartUpdateListener)
    }
  }, [currentVariant])

  return {
    cart,
    setCart,
    isFetching,
    setIsFetching,
    isLoaded,
    setIsLoaded,
    getMaxQuantity,
    syncMaxQuantity,
    cartUpdateListener,
    maxQuantity,
    cartItems
  }
}

export default useCartGlobal
